const dataRow = () => (
    {
        key: Date.now(),
        checked: false,
        no: undefined,
        item_code: undefined,
        item_name: undefined,
        sku: undefined,
        item_value: null,
        price_adjusted: null,
        price_adjustment: null,
        qty: 1,
        total_value: undefined,
        origin: undefined,
        channel_order_item: undefined,
        gst_paid: undefined,
        save_item: false,
        addRow: false,
        cancelRow: false,
        restore: false,
        originAmazon: false,
        isIgnoreProhibitedItem: false,
        classes: {
            item_code: 'error',
            item_name: 'error',
            sku: 'error',
            //item_value: 'error',
            price_adjusted: 'error',
            qty: '',
            total_value: '',
            origin: '',
            channel_order_item: 'error',
            gst_paid: ''
        }
    }
)
export default dataRow


// WEBPACK FOOTER //
// ./src/containers/orders/components/items/dataRow.js